import PropTypes from 'prop-types'

export default function DivCenterAlign({ children, className, ...props }) {
  return (
    <div className={`text-center mb-4 ${className ? className :''}`} {...props}>
      {children}
    </div>
  )
}

DivCenterAlign.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  className: PropTypes.string
}